import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FinalizeInvoiceMutationVariables = Types.Exact<{
  input: Types.FinalizeInvoiceInput;
}>;


export type FinalizeInvoiceMutation = { readonly __typename?: 'Mutation', readonly finalizeInvoice?: { readonly __typename?: 'Invoice', readonly _id: string, readonly patientType: Types.PatientType, readonly created: string, readonly updated: string, readonly invoiceStatus: Types.InvoiceStatus, readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null }, readonly payers: ReadonlyArray<{ readonly __typename?: 'Payer', readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null, readonly waived?: number | null, readonly exempt?: number | null } }> } | null };


export const FinalizeInvoiceDocument = gql`
    mutation finalizeInvoice($input: FinalizeInvoiceInput!) {
  finalizeInvoice(input: $input) {
    _id
    patientType
    created
    updated
    invoiceStatus
    balance {
      total
      paid
      due
      currency
    }
    payers {
      balance {
        total
        paid
        due
        currency
        waived
        exempt
      }
    }
  }
}
    `;
export type FinalizeInvoiceMutationFn = Apollo.MutationFunction<FinalizeInvoiceMutation, FinalizeInvoiceMutationVariables>;

/**
 * __useFinalizeInvoiceMutation__
 *
 * To run a mutation, you first call `useFinalizeInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeInvoiceMutation, { data, loading, error }] = useFinalizeInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeInvoiceMutation, FinalizeInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeInvoiceMutation, FinalizeInvoiceMutationVariables>(FinalizeInvoiceDocument, options);
      }
export type FinalizeInvoiceMutationHookResult = ReturnType<typeof useFinalizeInvoiceMutation>;
export type FinalizeInvoiceMutationResult = Apollo.MutationResult<FinalizeInvoiceMutation>;
export type FinalizeInvoiceMutationOptions = Apollo.BaseMutationOptions<FinalizeInvoiceMutation, FinalizeInvoiceMutationVariables>;